import {Component, OnInit} from '@angular/core';
import {PairingBonusService} from '../../../shared/services/pairing-bonus.service';
import {FormBuilder, FormGroup} from '@angular/forms';
import {BsDatepickerConfig} from 'ngx-bootstrap/datepicker';
import * as moment from 'moment';

@Component({
  selector: 'app-pairing-bonus',
  templateUrl: './pairing-bonus.component.html',
  styleUrls: ['./pairing-bonus.component.scss']
})
export class PairingBonusComponent implements OnInit {
  submitting = false;
  pairingBonus = [];
  total: any = 0;
  showSearch: any = false;
  searchForm: FormGroup;
  bsConfig: Partial<BsDatepickerConfig>;
  pagination = {
    page: 1,
    total: null,
    perpage: 15,
    pages: null
  };

  constructor(public pairingBonusService: PairingBonusService,
              private fb: FormBuilder) {
  }

  ngOnInit(): void {
    this.refresh();
  }

  refresh() {
    this.searchForm = this.fb.group({
      'transaction_no': [''],
      'matching': [''],
      'tds': ['']
    });
    this.get();
  }

  get(params: any = {}) {
    params.page = this.pagination.page;
    params.perpage = this.pagination.perpage;
    this.submitting = true;
    this.pairingBonus = [];
    this.pairingBonusService.get(params).subscribe(data => {
      if (data && data['data'] && data['data'].length > 0) {
        this.pairingBonus = data['data'];
        this.pagination = {
          page: data['pagination'].page,
          total: data['pagination'].total,
          perpage: data['pagination'].perpage,
          pages: data['pagination'].pages,
        };
        this.total = data.total_commission;
        this.triggerScroll();
      } else {
        this.pairingBonus = [];
      }
      this.submitting = false;
    }, error => {
      this.submitting = false;
    });
  }

  triggerScroll() {
    window.scrollTo(500, 500);
    window.scrollTo(500, 0);
  }

  onPageChange(page) {
    this.pagination.page = page;
    this.get();
  }

  search() {
    this.pagination = {
      page: 1,
      total: null,
      perpage: 15,
      pages: null
    };
    let params = {
      'transaction_no': (this.searchForm && this.searchForm.value) ? this.searchForm.value.transaction_no : '',
      'matching': (this.searchForm && this.searchForm.value) ? this.searchForm.value.matching : '',
      'tds': (this.searchForm && this.searchForm.value) ? this.searchForm.value.tds : ''
    };
    this.get(params);
  }
}
